import { Box } from "@outschool/backpack";
import { useScript } from "@outschool/ui-utils";
import React from "react";

function removeVideo(Wistia: any) {
  const video = Wistia && Wistia.api("24e4057lmp");
  if (video && typeof video.remove === "function") {
    video.remove();
  }
}

/**
 * Embeds a video from Wistia
 *
 * API documentation: https://wistia.com/support/developers/player-api
 */

export default function WistiaVideo({
  src,
  asyncClass
}: {
  src: string;
  asyncClass: string;
}) {
  useScript({
    src: "https://fast.wistia.com/assets/external/E-v1.js"
  });
  useScript({ src });

  React.useEffect(() => {
    return () => {
      removeVideo((global as any).Wistia);
    };
  }, []);

  return (
    <Box
      className="wistia_responsive_padding"
      sx={{ padding: "56.25% 0 0 0", position: "relative" }}
    >
      <Box
        className="wistia_responsive_wrapper"
        sx={{
          height: "100%",
          left: 0,
          position: "absolute",
          top: 0,
          width: "100%"
        }}
      >
        <Box
          className={`wistia_embed videoFoam=true ${asyncClass}`}
          sx={{ height: "100%", width: "100%" }}
        />
      </Box>
    </Box>
  );
}
